import { render } from "./Mb061.vue?vue&type=template&id=82784470&scoped=true"
import script from "./Mb061.vue?vue&type=script&lang=js"
export * from "./Mb061.vue?vue&type=script&lang=js"

import "./Mb061.vue?vue&type=style&index=0&id=82784470&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82784470"]])

export default __exports__